import axios from "axios";

export const getCustomRadius = (baseClientId) => {
  return axios
    .get(
      import.meta.env.VITE_ACTIVATE_BACKEND_API + "/api/customradius/" + encodeURIComponent(baseClientId)
    )
    .then((res) => res.data);
};

export const editCustomRadius = (baseClientId, data) => {
  return axios
    .post(
      import.meta.env.VITE_ACTIVATE_BACKEND_API +
        "/api/customradius/editcustomradiuscollection/" +
        encodeURIComponent(baseClientId),
      data
    )
    .then((res) => res.data);
};
